export default __webpack_public_path__ + "static/media/infra-27.27900c3f.webp";